import { languageUrl } from "../Config/Url";
import axios from "axios";

export const languageServices = {
  getById,
  getTranslations,
  create,
  search,
  update,
  updateTranslation,
  deleteLanguage,
  createTranslation
};

async function getById(languageId) {
  return axios
    .get(`${languageUrl}/${languageId}`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getTranslations(languageId) {
  return axios
    .get(`${languageUrl}/translations/${languageId}/list`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function create({ name, shortName, cultureCode, copyLanguageId }) {
  return axios
    .post(`${languageUrl}`, { name, shortName, cultureCode, copyLanguageId })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function search({ searchName, pageIndex, pageSize, sortName, isAsc }) {
  return axios
    .put(`${languageUrl}/search`, {
      searchName,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function update({ languageId, name, shortName, cultureCode }) {
  return axios
    .put(`${languageUrl}/${languageId}`, { name, shortName, cultureCode })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function updateTranslation({ languageId, resourceId, value }) {
  return axios
    .put(`${languageUrl}/translation/${languageId}`, { id: resourceId, value })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function createTranslation({ languageId, key, value }) {
  return axios
    .post(`${languageUrl}/translation/${languageId}`, { key: key, value:value })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function deleteLanguage(languageId) {
  return axios
    .delete(`${languageUrl}/${languageId}`)
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}
